import cxs from 'cxs';
import { COLOURS, FLATTENED_COLOURS, FONT_SIZES } from '../../../common/styles/vars';

const LOGO_PADDING = '23px';
const ADMIN_TOGGLE_WIDTH = '25px';
const ICON_CONTAINER = '> .icon-container';
const IMAGE = '> .image';

export const LOGO_CONTAINER = (admin) => cxs({
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'space-between',
  overflow: 'hidden',
  paddingLeft: admin ? '4px' : LOGO_PADDING,
  paddingRight: admin ? '4px' : LOGO_PADDING,
  paddingTop: admin ? '16px' : '0',
  paddingBottom: admin ? '16px' : '0'
});

export const ADMIN_TOGGLE = cxs({
  padding: 0,
  background: 'none',
  border: 0,
  cursor: 'pointer',
  width: ADMIN_TOGGLE_WIDTH
});

export const LOGO = (admin) => cxs({
  padding: 0,
  background: 'none',
  border: 0,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: admin ? 'column' : 'row',
  gap: admin ? '12px' : '0',
  width: admin ? '100%' : 'auto',

  [ICON_CONTAINER]: {
    display: 'flex',
    justifyContent: 'center'
  },
  [IMAGE]: {
    cursor: 'pointer',
    borderRadius: '4px',
    overflow: 'hidden'
  },

  ' > .text': {
    color: 'inherit'
  }
});

export const EMPTY_MENU_LINK_ICON = cxs({ width: '25px', height: '25px' });

const MENU_LINK_HOVER = ({
  selected, linkHoverColor, admin
}) => {
  if (selected) {return {};}

  return {
    ':hover': {
      background: linkHoverColor ? FLATTENED_COLOURS[linkHoverColor] :
      admin && COLOURS.grey.navMenuAdminHover || COLOURS.grey.athens.parthenon
    }
  };
};

export const MENU_LINK = (
{
  selected,
  selectedColour,
  rounded,
  indented,
  linkColour,
  linkHoverColor,
  linkSelectedColor,
  admin,
  exit = false








}) => cxs({
  background: selected ?
  linkSelectedColor && FLATTENED_COLOURS[linkSelectedColor] ||
  admin && COLOURS.grey.navMenuAdmin ||
  COLOURS.grey.sterling :
  'none',
  border: 0,
  borderRadius: admin ? '2px' : rounded && '6px' || 0,
  display: 'flex',
  width: '100%',
  fontSize: '15px',
  cursor: 'pointer',
  minHeight: admin ? '56px' : '50px',
  paddingLeft: admin ? '4px' : indented && '60px' || '30px',
  paddingRight: admin ? '4px' : '30px',
  paddingTop: admin ? '8px' : '0',
  paddingBottom: admin ? '8px' : '0',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  alignItems: 'center',
  flexDirection: admin ? 'column' : 'row',
  gap: admin ? '4px' : '0',

  [ICON_CONTAINER]: {
    display: 'flex',
    justifyContent: 'center'
  },

  '> .text': {
    fontSize: admin ? FONT_SIZES.small : FONT_SIZES.default,
    flex: 1,
    marginLeft: admin ? '0' : '30px',
    color: admin && !exit ?
    COLOURS.mono.white :
    selected && selectedColour && FLATTENED_COLOURS[selectedColour] ||
    linkColour && FLATTENED_COLOURS[linkColour] ||
    void 0
  },

  ...MENU_LINK_HOVER({ selected, linkHoverColor, admin })
});

export const LINKS_SEPARATOR = cxs({
  border: '0',
  borderBottom: '1px solid',
  borderColor: COLOURS.grey.mischka.russian,
  height: '0',
  margin: '10px'
});

export const TOP_MENU_LINKS = (admin) => cxs({
  display: 'flex',
  flex: 1,
  overflowY: 'auto',
  flexDirection: 'column',
  marginBottom: admin ? '0' : '35px',
  gap: admin ? '8px' : '0'
});

export const BOTTOM_MENU_LINKS = (admin) => cxs({
  gap: admin ? '8px' : '0',
  paddingBottom: '0',
  paddingTop: admin ? '16px' : '0'
});

export const EXIT_MENU_LINKS = cxs({
  paddingBottom: '16px'
});